import services from '@/http'
//import * as storage from '../storage'
import * as types from './mutation-types'


export const ActionGetCategorias = ({ commit }) => {
  return services.product_car_list.getCategoriesProdutos().then(res => {
    commit(types.SET_CATEGORIES_PRODUTOS, res.data.results)
  })
  
}

export const ActionGetProduct = ( context,{id_produto} ) => {
    return services.product_list.getProduct({id_produto:id_produto}).then(res => {
    context.commit(types.GET_PRODUTO, res.data.results[0])

  })
  
}
export const ActionDeleteGetProduct = ( context ) => {
    context.commit(types.GET_PRODUTO, {})
}



export const ActionSetChoicedProduct = (context,payload) => {
    context.commit(types.SET_CHOICED_PRODUCT, payload)
    localStorage.setItem('choiced_product', JSON.stringify(payload))
}

